import styled from 'styled-components/macro';
import TicketButton from 'components/Buttons/TicketButton/TicketButton';

export const ConfirmationButton = styled(TicketButton)`
  margin: 20px 0px 0px 0px;
  float: right;
`;
